import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import ImageLayer from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS';
import GeoTIFF from 'ol/source/GeoTIFF';
import WebGLTileLayer from 'ol/layer/WebGLTile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import {Style, Stroke, Fill, Circle as CircleStyle, RegularShape, Icon} from 'ol/style';

const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    })
  ],
  view: new View({
    center: [-9668262.45031853, 2411193.6258162702],  // playa del carmen en EPGS 3857
    zoom: 16,
  })
});

// Configuración de capas
// Capa satelital local usando GeoTIFF
// El archivo está en EPSG:32616 (UTM zone 16N), OpenLayers lo transformará automáticamente
const satelliteLayerConfig = {
  name: 'DemoPlayaDelCarmen',
  title: 'Vista Satelital',
  visible: true,
  type: 'geotiff',
};

// Capas vectoriales desde archivos GeoJSON locales
const vectorLayersConfig = [
  {
    name: 'manestad',
    title: 'manestad',
    visible: true,
    type: 'geojson',
    url: '/data/manestad.geojson',
  },
  {
    name: 'zi',
    title: 'zi',
    visible: true,
    type: 'geojson',
    url: '/data/zi.geojson',
  },
  {
    name: 'denue',
    title: 'denue',
    visible: true,
    type: 'geojson',
    url: '/data/denue.geojson',
  },
  {
    name: 'comercios',
    title: 'comercios',
    visible: true,
    type: 'geojson',
    url: '/data/comercios.geojson',
  },
];

// Crear capa satelital con GeoTIFF usando WebGL
// WebGLTileLayer tiene mejor soporte para GeoTIFF que ImageLayer
let satelliteLayer;
try {
  // URL del servidor Python (ejecutar: python3 serve-tif.py en otra terminal)
  // Usando versión LZW (sin compresión JPEG) del archivo
  // const geoTiffUrl = 'http://localhost:8000/data/CancunRGB_COG2_LZW.tif';
  const geoTiffUrl = '/data/CancunRGB_COG2_LZW.tif';
  
  // Configuración final: Bandas RGB + normalize + estilo WebGL con transparencia para fondos
  const geoTiffSource = new GeoTIFF({
    sources: [
      {
        url: geoTiffUrl,
        // Bandas RGB
        bands: [1, 2, 3], // Red, Green, Blue
      },
    ],
    normalize: true, // Normalizar valores
  });

  console.log('Configuración final: Bandas RGB con transparencia para fondos');
  console.log('GeoTIFF source creado:', geoTiffSource);
  console.log('URL del GeoTIFF:', geoTiffUrl);
  
  satelliteLayer = new WebGLTileLayer({
    source: geoTiffSource,
    visible: satelliteLayerConfig.visible,
    opacity: 1.0,
    // Estilo WebGL que hace transparentes los fondos negro y blanco (umbrales óptimos)
    style: {
      color: [
        'case',
        // Si todos los valores RGB son muy oscuros (negro o casi negro), hacer transparente
        // Umbral 0.05 para capturar bordes negros sin afectar la imagen
        ['all',
          ['<', ['band', 1], 0.05],
          ['<', ['band', 2], 0.05],
          ['<', ['band', 3], 0.05]
        ],
        [0, 0, 0, 0], // Transparente para negro
        // Si todos los valores RGB son muy claros (blanco o casi blanco), hacer transparente
        // Umbral 0.95 para capturar bordes blancos sin afectar la imagen
        ['all',
          ['>', ['band', 1], 0.95],
          ['>', ['band', 2], 0.95],
          ['>', ['band', 3], 0.95]
        ],
        [0, 0, 0, 0], // Transparente para blanco
        // Para todos los demás valores, usar los colores RGB normalizados
        [
          'array',
          ['band', 1], // Red
          ['band', 2], // Green
          ['band', 3], // Blue
          1.0, // Alpha
        ]
      ],
    },
  });

  satelliteLayerConfig.olLayer = satelliteLayer;
  map.addLayer(satelliteLayer);
  
  // Manejar errores de carga
  geoTiffSource.on('error', (error) => {
    console.error('Error al cargar GeoTIFF:', error);
    console.error('Detalles del error:', error.message);
    // Mostrar mensaje al usuario
    const errorMsg = document.createElement('div');
    errorMsg.style.cssText = 'position:absolute;top:50px;left:10px;background:red;color:white;padding:10px;border-radius:5px;z-index:1000;';
    errorMsg.textContent = 'Error al cargar la capa satelital. Asegúrate de ejecutar: python3 serve-tif.py';
    document.body.appendChild(errorMsg);
    setTimeout(() => errorMsg.remove(), 5000);
  });
  
  // Log para debugging - verificar estado
  geoTiffSource.on('change', (evt) => {
    const state = geoTiffSource.getState();
    console.log('Estado de GeoTIFF:', state);
    if (state === 'ready') {
      console.log('GeoTIFF cargado y listo');
    } else if (state === 'error') {
      console.error('GeoTIFF en estado de error');
    } else if (state === 'loading') {
      console.log('GeoTIFF cargando...');
    }
  });
  
} catch (error) {
  console.error('Error al crear capa GeoTIFF:', error);
  console.error('Stack trace:', error.stack);
  // Crear una capa vacía para evitar que se rompa la aplicación
  satelliteLayer = new WebGLTileLayer({
    visible: false,
  });
  satelliteLayerConfig.olLayer = satelliteLayer;
}

// Estilos personalizados basados en archivos SLD de GeoServer
// manestad: Polígono beige (#beb297) con opacidad 0.61
const manestadStyle = new Style({
  fill: new Fill({
    color: [190, 178, 151, 0.61], // #beb297 con opacidad 0.61
  }),
  stroke: new Stroke({
    color: [35, 35, 35, 0.61], // #232323 con opacidad 0.61
    width: 1,
    lineJoin: 'bevel',
  }),
});

// zi: Polígono naranja (#e77148) con opacidad 0.44
const ziStyle = new Style({
  fill: new Fill({
    color: [231, 113, 72, 0.44], // #e77148 con opacidad 0.44
  }),
  stroke: new Stroke({
    color: [35, 35, 35, 0.44], // #232323 con opacidad 0.44
    width: 1,
    lineJoin: 'bevel',
  }),
});

// denue: Punto morado (#8d5a99) círculo tamaño 7
const denueStyle = new Style({
  image: new CircleStyle({
    radius: 3.5, // tamaño 7 / 2
    fill: new Fill({
      color: '#8d5a99',
    }),
    stroke: new Stroke({
      color: '#232323',
      width: 0.5,
    }),
  }),
});

// comercios: Punto con icono SVG de tienda (shop_convenience.svg) tamaño 24
// El SVG original tiene viewBox de 579.997, así que escalamos a 24px
const comerciosStyle = new Style({
  image: new Icon({
    src: '/shop_convenience.svg',
    scale: 24 / 579.997, // Escalar de 579.997 a 24px
    anchor: [0.5, 0.5], // Centrar el icono en el punto
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
  }),
});

// Función para obtener el estilo apropiado según el nombre de la capa
function getStyleForLayer(layerName) {
  switch (layerName) {
    case 'manestad':
      return manestadStyle;
    case 'zi':
      return ziStyle;
    case 'denue':
      return denueStyle;
    case 'comercios':
      return comerciosStyle;
    default:
      // Estilo por defecto (no debería usarse, pero por seguridad)
      return new Style({
        stroke: new Stroke({
          color: '#3399CC',
          width: 2,
        }),
        fill: new Fill({
          color: 'rgba(51, 153, 204, 0.2)',
        }),
        image: new CircleStyle({
          radius: 5,
          fill: new Fill({
            color: '#3399CC',
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 1,
          }),
        }),
      });
  }
}

// Crear capas vectoriales desde archivos GeoJSON locales
const vectorLayers = vectorLayersConfig.map((layerConfig) => {
  const format = new GeoJSON();
  
  // Cargar GeoJSON manualmente para mejor control
  const vectorSource = new VectorSource({
    // No usar url directamente, cargaremos manualmente
  });

  const vectorLayer = new VectorLayer({
    source: vectorSource,
    visible: layerConfig.visible,
    style: getStyleForLayer(layerConfig.name), // Estilo personalizado basado en SLD
  });
  
  layerConfig.olLayer = vectorLayer; // Guardar referencia a la capa de OpenLayers
  layerConfig.vectorSource = vectorSource; // Guardar referencia a la fuente para GetFeatureInfo
  
  // Cargar GeoJSON manualmente usando fetch
  fetch(layerConfig.url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      const features = format.readFeatures(data, {
        featureProjection: 'EPSG:3857',
        dataProjection: 'EPSG:3857',
      });
      vectorSource.addFeatures(features);
    })
    .catch(error => {
      console.error(`Error al cargar capa ${layerConfig.name}:`, error);
    });
  
  return vectorLayer;
});

// Añadir capas vectoriales al mapa
vectorLayers.forEach((layer) => map.addLayer(layer));

// Combinar todas las capas para el control de capas
const allLayers = [satelliteLayerConfig, ...vectorLayersConfig];

// Crear controles de capas en la interfaz
const layersContainer = document.getElementById('layers');
allLayers.forEach((layer) => {
  const label = document.createElement('label');
  const checkbox = document.createElement('input');
  checkbox.type = 'checkbox';
  checkbox.checked = layer.visible;
  checkbox.addEventListener('change', () => {
    layer.olLayer.setVisible(checkbox.checked);
  });
  label.appendChild(checkbox);
  label.appendChild(document.createTextNode(` ${layer.title}`));
  layersContainer.appendChild(label);
});

// Función para reaccionar al hacer clic - GetFeatureInfo nativo para capas vectoriales
map.on('singleclick', (evt) => {
  const coordinate = evt.coordinate;
  const pixel = evt.pixel;

  // Limpiar la tabla previa
  const tableBody = document.querySelector('#info-table tbody');
  tableBody.innerHTML = '';

  // Obtener todas las capas vectoriales visibles (tipo geojson)
  const visibleVectorLayers = vectorLayersConfig.filter(
    (layer) => layer.olLayer.getVisible() && layer.type === 'geojson'
  );

  // Si no hay capas vectoriales visibles, no hacer nada
  if (visibleVectorLayers.length === 0) return;

  // Buscar features en el punto de click usando forEachFeatureAtPixel
  // Esto busca en todas las capas visibles del mapa
  let featureFound = false;
  
  map.forEachFeatureAtPixel(pixel, (feature, layer) => {
    // Solo procesar si es una capa vectorial de nuestras capas configuradas
    const layerConfig = vectorLayersConfig.find(
      (config) => config.olLayer === layer
    );
    
    if (layerConfig && !featureFound) {
      featureFound = true;
      const properties = feature.getProperties();
      
      // Excluir la geometría de las propiedades (no queremos mostrarla en la tabla)
      delete properties.geometry;
      
      // Rellenar la tabla con los atributos
      for (const [key, value] of Object.entries(properties)) {
        const row = document.createElement('tr');
        const keyCell = document.createElement('td');
        const valueCell = document.createElement('td');
        keyCell.textContent = key;
        valueCell.textContent = value !== null && value !== undefined ? String(value) : 'N/A';
        row.appendChild(keyCell);
        row.appendChild(valueCell);
        tableBody.appendChild(row);
      }
      
      return true; // Detener la búsqueda después de encontrar el primer feature
    }
  }, {
    hitTolerance: 5, // Tolerancia en píxeles para hacer click más fácil
    layerFilter: (layer) => {
      // Solo buscar en capas vectoriales de nuestras capas configuradas
      return vectorLayersConfig.some(config => config.olLayer === layer);
    }
  });

  // Si no se encontró ningún feature, mostrar mensaje
  if (!featureFound) {
    tableBody.innerHTML = '<tr><td colspan="2">No se encontraron datos en este punto</td></tr>';
  }
});

